<template>
  <div :style="{height:height*0.59+'px',width:width*0.374+'px'}" style="background: #fff;border-radius:5px">
    <x-scroll :contentArr="zhibu" :height="height*0.59" :lineNum="1" :width="width*0.374" :time="15000" :startTime="6000" v-if="zhibu.length">
      <div class="wzb-wrapper" slot="scroll" slot-scope="props" :style="{height:height*0.59+'px',width:width*0.374+'px'}">
        <div class="total" :style="{fontSize:no125?'19px':'15px',width:no125?'60px':'50px',height:no125?'75px':'55px'}">
          <p>党员</p>
          <p>{{props.todo.count}}人</p>
        </div>
        <div class="wzb-left">
          <div class="zhibu-name" :style="{fontSize:no125?'33px':'29px'}">{{props.todo.name}}</div>

        </div>
        <div class="wzb-right">
          <img v-if="props.todo.pic" :src='props.todo.pic' :style="{height:height*0.5+'px',}" />
          <img v-else src="../../../assets/images/noShequPic.png" :style="{height:height*0.5+'px',}" />
        </div>
      </div>
    </x-scroll>
  </div>
</template>

<script>
  import xScroll from '../../../components/xScroll'
  export default {
    components: {
      xScroll
    },
    props:{
      height:null,
      width:null,
      zhibu:null
    },
    computed:{
      no125 () {
        return this.height/0.436>750 || this.width > 1550?true:false
      },
    },
    data () {
      return {
      }
    }
  }
</script>

<style scoped>
  .wzb-wrapper{
    /*width:700px;*/
    border:1px solid #fff;
    border-radius: 5px;
    color:#444;
    display: flex;
    position: relative;
    /*height: 260px;*/
  }
  .wzb-right{
    padding:20px
  }
  .wzb-left{
    padding: 20px 0 20px 20px ;
    display: flex;
    flex:1;
    flex-flow: column;
    justify-content:center;
    text-align: center;
  }
  .total{
    padding-top:5px;
    /*width: 60px;*/
    /*height: 75px;*/
    position: absolute;
    color:#fff;
    /*font-size:19px;*/
    top:-1px;
    left:10px;
    text-align: center;
    background: url('../../../assets/images/blue.png') no-repeat;
    background-size:100% 100%
  }
  .zhibu-name{
    font-weight: 600;
    max-width: 250px;
    margin: 10px auto 0px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }
</style>
